export default __webpack_public_path__ + "media/images/banners/bnr_ishikawa-1c206295b18ea1742ef9eed6daad6086.png";